export default class Contact {
	constructor() {
		this.Title = null;
		this.FirstName = null;
		this.MiddleName = null;
		this.Surname = null;

		this.AuthorisedToAct = null;

		this.Email = {};
		this.Phone = {};
		this.Address = {};
	}
}
